import React from 'react'

import { useTranslation } from 'react-i18next'

import { ErrorView } from '@/Components/error/ErrorView'

export const SearchPageNoResults: React.FC = () => {
  const { t } = useTranslation()

  const NO_RESULTS_VIEW_ERROR_PROPS = {
    headline: t('search.noResults.title'),
    text: t('search.noResults.subtitle'),
    image: <div className="spaceman-sad" />,
  }
  return <ErrorView {...NO_RESULTS_VIEW_ERROR_PROPS} />
}
